// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler;

export const ResetProduct: HandlerType = props => {
    props.dispatch({
        type: "Store/Components/ScratchAndDentForm/ResetProduct",
    });
};

export const chain = [ResetProduct];

const resetProduct = createHandlerChainRunnerOptionalParameter(chain, {}, "ResetProduct");
export default resetProduct;
